import * as React from "react";

function SvgBBiconsInfoNotice(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <path
        d="M100 1a99 99 0 1099 99 99 99 0 00-99-99zm10.4 149.17q0 6.24-3 9.45a9.86 9.86 0 01-7.54 3.2 9.4 9.4 0 01-7.43-3.28q-2.86-3.27-2.86-9.37V90.68q0-6.17 2.86-9.29a9.61 9.61 0 017.43-3.13 10 10 0 017.54 3.13c2 2.08 3 5 3 8.68zM109 58.76a12.85 12.85 0 01-8.85 3.31 13.47 13.47 0 01-9.09-3.26q-3.76-3.27-3.77-9.23a11.47 11.47 0 013.87-8.9 13 13 0 019-3.5 13.36 13.36 0 018.76 3.17q3.82 3.18 3.82 9.23-.02 5.88-3.74 9.18z"
        data-name="Obecn\xE9 ikony"
      />
    </svg>
  );
}

export default SvgBBiconsInfoNotice;
